<template>
  <div>
    <queryFrame @handlePage='handlePage' @handlePageSize='handlePageSize' :disablePage='true'
          :count="count" :current="page.currentPage">
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>数据直连名称:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable
              v-model.trim='query.ruleName'></lk-input>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns='columns' :data='tableData'/>
      </div>
    </queryFrame>
  </div>
</template>
<script>
import queryFrame from '../../components/frame/QueryFrame.vue';
import mapState from '../../mixins/mapState';
import queryMixins from '../../mixins/queryMixins';
import dataDirect from '../../services/dataDirect';
import utils from '../../libs/utils';

export default {
  name: 'ruleList',
  mixins: [mapState, queryMixins],
  components: { queryFrame },
  data() {
    return {
      query: {},
      count: 0,
      columns: [
        {
          title: '数据直连名称',
          key: 'ddiRuleName',
        },
        {
          title: '备注',
          key: 'remark',
        },
        {
          title: '操作',
          render: (h, { row }) => h('div', [
            h('lk-button', {
              props: {
                size: 'small',
                type: 'text',
                disabled: !this.handlePermission('dataDirectRuleCheck'),
              },
              on: {
                click: () => {
                  this.$router.push({
                    name: 'dataDirectRuleCheck',
                    params: {
                      id: row.ddiRuleId,
                      ruleType: row.ddiRuleAccountType,
                    },
                  });
                },
              },
            }, '查看'),
            h('lk-button', {
              props: {
                size: 'small',
                type: 'text',
                disabled: !this.handlePermission('dataDirectRuleEdit'),
              },
              on: {
                click: () => {
                  this.$router.push({
                    name: 'dataDirectRuleEdit',
                    params: {
                      id: row.ddiRuleId,
                      ruleType: row.ddiRuleAccountType,
                    },
                  });
                },
              },
            }, '编辑'),
          ]),
        },
      ],
      tableData: [],
    };
  },
  methods: {
    clear() {
      this.query = {};
    },
    getData() {
      dataDirect.getRuleList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          const { data } = res.data;
          data.list.forEach((el) => {
            const result = {};
            utils.exchangeTable(el, result);
            this.tableData.push(result);
          });
          this.count = data.count;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>
</style>
